export default __webpack_public_path__ + "public/images/home/presets/small-flat@2x.png?0c507089";